import React from 'react';

export default function Harness({ className }) {
    return (
        <svg className={`${className}  w-8 h-8`} fill="#e20303" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            {/* Head */}
            <circle cx="12" cy="4" r="2"/>
            
            {/* Body/Torso */}
            <path d="M12 6v8"/>
            
            {/* Shoulders/Chest straps */}
            <path d="M8 8l-3 4m11-4l3 4"/>
            <path d="M6 14h12"/>
            
            {/* Waist/Leg straps */}
            <path d="M9 14v4l-3 2m9-6v4l3 2"/>
            
            {/* Back D-ring (common harness feature) */}
            <circle cx="12" cy="10" r="1.5" fill="none" stroke="#e20303" strokeWidth="1"/>
            
            {/* Legs */}
            <path d="M9 20l-1 2m6-2l1 2"/>
        </svg>
    );
}